import Enum from "../../../../../../enums/Enum";

const TypeEnum = new Enum({
    DIAGNOSTICS: {name: "DISC Diagnostics"},
    RADIOLOGY: {name: "Radiology"},
    LABORATORY: {name: "Laboratory"},
    HOSPITALIZATION: {name: "Hospitalization"},
    SURGERY: {name: "Surgery"},
    EXAMINATIONS: {name: "Examinations"},
    GENETICS: {name: "Genetics"},
    VACCINATION: {name: "Vaccination"},
    NUTRITION: {name: "Nutrition"},
    MEDICAL_DEVICES: {name: "Medical Devices"}
});

export default TypeEnum;